import { ReactElement } from 'react'
import {
  FlexWrapper,
  DropdownWrapper,
  EditableDropdown,
  SectionTitle,
  PageWrapper,
  Input,
  Button
} from '../../../../components'
import strings from '../../../../locale/en'
import SecondaryButton from 'react-bootstrap/Button'

const TestSetting = (): ReactElement => {
  const {
    menu: {
      admin: {
        createTest: {
          selectTestType,
          testSetting,
          testName,
          testCode,
          attempts,
          instructions
        }
      }
    },
    test: { duration, enterDuration },
    button: { save, cancel }
  } = strings
  return (
    <PageWrapper id="container">
      <SectionTitle title={testSetting} hasBorder />
      <FlexWrapper>
        <DropdownWrapper>
          <EditableDropdown
            title={selectTestType}
            isRequired
            dropdownList={[]}
            placeholder={selectTestType}
            handleSelect={() => {}}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <Input
            label={testName}
            placeholder={testName}
            value=""
            name={testName}
            onBlur={() => {}}
            error={''}
            onChange={() => {}}
            isRequired
            hasPadding={false}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <Input
            label={duration}
            placeholder={enterDuration}
            value=""
            name={duration}
            onBlur={() => {}}
            error={''}
            onChange={() => {}}
            isRequired
            hasPadding={false}
            inputType="number"
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <Input
            label={testCode}
            placeholder={testCode}
            value=""
            name={testCode}
            onBlur={() => {}}
            error={''}
            onChange={() => {}}
            isRequired
            hasPadding={false}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <Input
            label={attempts}
            placeholder={attempts}
            value=""
            name={attempts}
            onBlur={() => {}}
            error={''}
            onChange={() => {}}
            isRequired
            hasPadding={false}
            inputType="number"
          />
        </DropdownWrapper>
      </FlexWrapper>
      <DropdownWrapper width="80%">
        <Input
          label={instructions}
          value=""
          name={instructions}
          onBlur={() => {}}
          error={''}
          onChange={() => {}}
          isRequired
          hasPadding={false}
          inputType="textarea"
        />
      </DropdownWrapper>
      <FlexWrapper justifyContent="center">
        <SecondaryButton variant="outline-secondary">{cancel}</SecondaryButton>
        <Button>{save}</Button>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default TestSetting
